import axios from 'axios';

const log = require("loglevel").getLogger("MarketingService");
log.setLevel("error");

export const loadMarketingById = id => {
	return axios.post(`${process.env.REACT_APP_HOST_URL}/marketing/get/id`, {id})
		.then(async response => {
			const res = response.data.data;
			log.debug("MarketingService -> loadMarketingById -> return");
			return res;
		})
		.catch(response => {
			log.debug("MarketingService -> loadMarketingById -> error: ");
			log.debug(response);
			return null;
		});
};

export const loadMarketing = (selectedFilters, forceReload) => {
	console.log(selectedFilters);

	return axios.post(`${process.env.REACT_APP_HOST_URL}/marketing/get`, {selectedFilters, forceReload: forceReload === true})
		.then(async response => {
			const res = response.data;
			log.debug("MarketingService -> loadMarketing -> return");
			return res;
		})
		.catch(response => {
			log.debug("MarketingService -> loadMarketing -> error: ");
			log.debug(response);
			return null;
		});
};
